import { render, staticRenderFns } from "./settlementDetail.vue?vue&type=template&id=77d3c64f&scoped=true"
import script from "./settlementDetail.vue?vue&type=script&lang=js"
export * from "./settlementDetail.vue?vue&type=script&lang=js"
import style0 from "./settlementDetail.vue?vue&type=style&index=0&id=77d3c64f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d3c64f",
  null
  
)

export default component.exports